import { axiosJwt } from '@/shared/auth/axios-lib'
import { errorHandler } from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_DESPESASGERAIS_URL}${process.env.VUE_APP_API_PATH}`

export default {
    obterPorId(despesaItemId) {
        return axiosJwt
            .get(`${api}/despesasgerais/fornecedores/itensdespesas/${despesaItemId}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterItemDespesaOpcoes() {
        return axiosJwt
            .get(`${api}/despesasgerais/fornecedores/itensdespesas/opcoes`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    inserirItemDespesa(itemDto) {
        return axiosJwt
            .post(`${api}/despesasgerais/fornecedores/itensdespesas/inserir`, itemDto)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    atualizarItemDespesa(itemDto) {
        return axiosJwt
            .put(`${api}/despesasgerais/fornecedores/itensdespesas/atualizar`, itemDto)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    excluirItemDespesa(despesaItemId) {
        return axiosJwt
            .delete(`${api}/despesasgerais/fornecedores/itensdespesas/${despesaItemId}/excluir`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterItens(idsItensDto) {
        return axiosJwt
            .post(`${api}/despesasgerais/fornecedores/itensdespesas/obteritens`, idsItensDto)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    }
}